<template>
  <svg :width="width" :height="height" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.16683 1.33331L5.00016 5.49998L0.833496 1.33331"
      :stroke="color"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'ArrowDownLight',
  props: {
    height: {
      type: String,
      default: '15'
    },
    width: {
      type: String,
      default: '20'
    },
    color: {
      type: String,
      default: '#000000'
    }
  }
}
</script>
